import { HStack, Text, useConst } from '@chakra-ui/react';
import { getMeetingStatus } from '@util/helpers/card.helpers';
import { useBreakpoints, useControlBarState, useMeetingTimeStatus } from '@util/hooks';
import { format, formatDistanceStrict, isSameYear, isToday } from 'date-fns';
import { useMemo } from 'react';

export function StatusTimeLabel({
  meeting,
  bot,
  opacity = 1,
  includeDate, // reskin todo: this is uber prop-drilled, find a more sustainable way to pass props/configuration into the reskin meeting card
  showAgoText = false,
  showFullDate = false,
  showStatus = true,
  isLensSourceCard,
  ...props
}) {
  const now = useConst(new Date());
  const stateForMeetingUI = useControlBarState(meeting, bot);
  const meetingTimeStatus = useMeetingTimeStatus(meeting);
  const isLive = meetingTimeStatus === 'live';
  const isLiveRecording = stateForMeetingUI.text === 'Active • Recording';

  const status = useMemo(
    () => getMeetingStatus(stateForMeetingUI, isLive),
    [stateForMeetingUI, isLive]
  );

  const { isMobile } = useBreakpoints();

  if (!meeting?.start_at || !meeting?.end_at) {
    return null;
  }

  let timeText = format(meeting?.start_at, 'hh:mm') + '-' + format(meeting?.end_at, 'hh:mm aaa');
  if (isMobile) {
    timeText = format(meeting?.start_at, 'hh:mm aaa');
  }

  let dateFormat = isSameYear(meeting?.start_at, new Date()) ? 'E LLL d, ' : 'PP, ';
  if (showFullDate) {
    dateFormat = 'EEEE, MMMM d, ';
  }

  return (
    <HStack
      bgColor={isLiveRecording ? status?.bgColor : 'transparent'}
      color={isLiveRecording ? status?.color : 'surface.onSurfaceVariant'}
      rounded='full'
      px={1}
      py={0.5}
      pr={3}
      pl={2}
      fontSize='10px'
      fontWeight={500}
      w='fit-content'
      data-testid='status-time-label-stack'
      {...props}
    >
      {showStatus && !isLensSourceCard && status?.leftElement}
      <Text>
        {includeDate && (
          <Text
            as='span'
            fontSize={{ base: 'xs', xl: '13px' }}
            fontWeight={600}
          >
            {isToday(meeting?.start_at) ? 'Today, ' : format(meeting?.start_at, dateFormat)}
          </Text>
        )}
        <Text
          as='span'
          whiteSpace='nowrap'
          fontSize={{ base: 'xs', xl: '13px' }}
          fontWeight={600}
          opacity={opacity}
        >
          {timeText}
        </Text>
      </Text>
      {meetingTimeStatus === 'done' && showAgoText && (
        <Text
          fontSize={{ base: 'xs', xl: '13px' }}
          fontWeight={600}
          opacity={opacity}
          whiteSpace='nowrap'
          alignSelf='flex-start'
        >
          {formatDistanceStrict(meeting?.end_at || now, now, {
            addSuffix: true
          })}
        </Text>
      )}
    </HStack>
  );
}
